.section {
    animation: slideInFromTop 0.2s ease-out forwards;
}

.sectionIcon {
    width: 1.2rem;
    height: 1.2rem;
}

.expandButton {
    align-self: flex-start;
    padding-left: 0;
    font-weight: 400;

    &:hover {
        background: transparent;
        text-decoration: underline;
    }
}

@keyframes slideInFromTop {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
